import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';
import { HoverBox } from '../../../hoverBox/HoverBox';

export const BounceLine = ({ priceToBreak, size, scaleY, portalRef }) => {
  const json = {
    Category: 'Setup',
    Type: 'Bounce',
    'Bounce Price': ApplyRounding(Number(priceToBreak), 2),
  };

  return (
    <>
      {scaleY ? (
        <>
          <line
            stroke={colors.blue}
            strokeWidth={2}
            x1={0}
            x2={size}
            y1={scaleY(Number(priceToBreak))}
            y2={scaleY(Number(priceToBreak))}
          ></line>
          <HoverBox
            json={json}
            topBoundary={scaleY(Number(priceToBreak)) - 2}
            bottomBoundary={scaleY(Number(priceToBreak)) + 2}
            leftBoundary={0}
            rightBoundary={size}
            portalRef={portalRef}
          />
        </>
      ) : null}
    </>
  );
};

BounceLine.propTypes = {
  priceToBreak: PropTypes.number,
  scaleY: PropTypes.func,
  size: PropTypes.any,
  portalRef: PropTypes.object,
};
